<template>
  <section class="view" stytle="min-height: 90vh;">
        <Breadcrumb :breadcrumb="breadcrumb" v-if="!for_personnel"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text"
                v-html='`Please answer the questions below and click "Complete" when you are finished.`'
            />
        </div>

        <div class="tab-content" v-show="survey_questions.length" style="margin-top:40px;">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="w-100 table-responsive overflow-y--1" style="min-height:750px;">
                                    <table class="table">
                                        <thead style="background-color: #f1f1f1;">
                                            <tr>
                                                <th v-for="(item, i) in table_headers" :key="i" scope="col" v-html="item.name"/>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, i) in survey_questions" :key="i">
                                                <td v-html="i+1"/>
                                                <td v-html="item.question"/>
                                                <td>
                                                    <div class="formdynamic__item__field" v-if="item.response_type === 1">
                                                        <select
                                                            class="input-field custom-select"
                                                            :required="true"
                                                            v-model="item.survey_answer_id"
                                                            :id="`select_survey${i}`"
                                                        >
                                                            <option value='' v-html="'Select an option'"/>
                                                            <option v-for="(value, j) in item.answers_data" :key="j" :value="value.id" v-html="value.answer_text"/>
                                                        </select>
                                                    </div>
                                                    <div class="d-inline-block" v-else-if="item.response_type === 2">
                                                        <div v-for="(value, j) in boolean_data" :key="j" class="form-check custom-control-inline">
                                                            <input 
                                                                class="form-check-input" 
                                                                type="radio"
                                                                :name="`radio${i}`"
                                                                v-model="item.boolean_field" 
                                                                :id="`radio${i}`"
                                                                :value="value.id"
                                                                checked="checked"
                                                            />
                                                            <label 
                                                                :ref="`radio${i}`"
                                                                :class="'ml-1 mt-1 form-check-label'" 
                                                                v-html="value.name"
                                                            />
                                                        </div> 
                                                    </div>
                                                    <div class="formdynamic__item__field" v-if="item.response_type === 3">
                                                        <textarea
                                                            placeholder="Write your answer here"
                                                            :id="`textarea_survey${i}`"
                                                            v-model="item.comment_field"
                                                            :maxlength="500"
                                                            :required="true"
                                                            rows="5"
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- <pre>{{ survey_questions }}</pre> -->
                                    <div class="modal__buttons d-md-flex justify-content-md-end">
                                        <!-- <button type="button" class="modal__buttons__item cancel ml-3 mr-0" style="margin-top:0px;" data-dismiss="modal" aria-label="Close" v-html="'Cancel'"/> -->
                                        <button class="modal__buttons__item" v-html="`Complete`" @click="pollCompletion()"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <WaitingModal/>

        <SuccessfullModal
            :message="`Survey completion success`"
            :second_message="`Thanks for completing the survey! Your responses have been recorded.`"
            @ConfirmSuccess="dashboardReturn()"
        />

    </section>
</template>

<script>

import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import SuccessfullModal     from    '@/components/SuccessfullModal'
import Resources            from    './resources'
// import DinamicTable         from    '@/components/DinamicTable'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: 'SurveyTestCompletion',

    props: [
        'for_personnel'
    ],

    components: {
        Breadcrumb,
        WaitingModal,
        SuccessfullModal,
    },
    
    data() 
    {
        return {
            notyf,
            user: this.get_user(),
            child_href: '/qc-surveys-detail/',
            title_page: 'Survey Test - Survey Completion',
            
            rest_api: `${this.for_personnel ? 'survey_mails_personnel' : 'survey_mails'}/${JSON.stringify({
                test_completion: true,
                survey_mail_id: this.$route.params.id,
                associate_id: this.get_user() ? this.get_user().id : null,
            })}`,

            main_rest_api: `${this.for_personnel ? 'survey_mails_personnel' : 'survey_associate_answer'}`,
            survey_associate_answer: {},
            table_headers: Resources.table_headers,
            breadcrumb: Resources.breadcrumb,
            add_btn: 'Add Survey',
            single_select: false,
            table_selection: [],
            search: '',
            global_index: '',
            single_object: {},
            survey_questions: [],
            array_options: {},
            select_ids: [],
            boolean_data: [
                {
                    id: true,
                    name: 'Yes',
                },
                {
                    id: false,
                    name: 'No',
                },
            ],
        }
    },

    methods: 
    {
        pollCompletion()
        {
            if(this.survey_questions.length)
            {
                let response = []

                for(let i = 0; i < this.survey_questions.length; i++)
                {
                    let question = this.survey_questions[i]

                    if(question.response_type === 1 && question.survey_answer_id === '' || question.survey_answer_id === null)
                    {
                        window.$(`#select_survey${i}`).focus()
                        notyf.error('You must complete the current survey')
                        return false
                    }
                    else if(question.response_type === 2 && question.boolean_field !== true && question.boolean_field !== false)
                    {
                        notyf.error('You must complete the current survey')
                        return false
                    }
                    else if(question.response_type === 3 && question.comment_field === '' || question.comment_field === null)
                    {
                        window.$(`#textarea_survey${i}`).focus()
                        notyf.error('You must complete the current survey')
                        return false
                    }

                    response.push({
                        survey_question_id: question.id,
                        survey_answer_id: question.survey_answer_id,
                        boolean_field: question.boolean_field,
                        comment_field: question.comment_field,
                    })
                }
                this.postingCurrentSurvey(response)
            }
        },

        async postingCurrentSurvey(request_data)
        {
            this.loader(true)
            
            let post_data = { 
                survey_associate_answer_id: this.survey_associate_answer.id,
                survey_associate_responses: request_data
            }

            let response;

            if(this.for_personnel)
            {

                response = await this.post(this.main_rest_api, post_data, {}, false)
            }
            else
            {
                response = await this.post(this.main_rest_api, post_data)
            }

            this.loader()

            if(response.status)
            {
                window.$('#successfull-modal').modal('show')
            }
            else
            {
                this.error_handling(response)
            }
        },

        dashboardReturn()
        {
            window.location.href = '/'
            return true
        },

        fill_data(data)
        {
            if(!data.status)
            {
                window.location.href = '/'
                return false
            }

            this.survey_associate_answer = data.survey_associate_answer
            this.survey_questions = data.survey_questions
        },
    },

    async mounted()
    {
        await this.api_request()
    },

    computed:
    {
        selected()
        {
            const bool = this.survey_questions.filter(item => item.checked)
            return Boolean(bool.length)
        }
    },
}

</script>